// @ts-nocheck -- removing type checking for now due to Ember Data mixin compatibility
import { InvalidError } from '@ember-data/adapter/error';
import Model, { attr, belongsTo, hasMany } from '@ember-data/model';

import { apiAction } from '@mainmatter/ember-api-actions';

import RegisterOrganizationValidations from 'register-partners-js/validations/register-organization';

export const ME_LEGAL_CODES = ['1000', '1100', '1200', '1300', '1500', '1600', '1700', '1900'];

export const SCI_LEGAL_CODE = '6540';
export const SC_LEGAL_CODE = '6599';

export default class RegisterOrganization extends Model.extend(RegisterOrganizationValidations) {
  @attr('string') name;
  @attr('string') createdAt;
  @attr('boolean') underRegistration;
  @attr('string') depositPaymentId;
  @attr('string') addressLineOne;
  @attr('string') addressLineTwo;
  @attr('string') addressZipcode;
  @attr('string') addressCity;
  @attr('string') addressCountry;
  @attr('string') legalCountry;
  @attr legalRegistrationDate;
  @attr('string') legalNumber;
  @attr('string') originalPricePlanCode;
  @attr('string') legalFormCreditsafeCode;
  @attr('string') originalRecurrence;
  @attr('string') annualTurnover;
  @attr('string') yearlyTransactionVolume;
  @attr('number') maxSinglePaymentAmount;
  @attr companyCreationFromScratch;
  @attr natureOfOperations;
  @attr features;
  @attr('string', { allowNull: true, defaultValue: null }) businessActivityEntityType;
  @attr({ defaultValue: null }) businessRelationships;
  @attr('string') businessRelationshipsOther;
  @attr({ defaultValue: null }) incomingTransfersOrigin;
  @attr({ defaultValue: null }) outgoingTransfersDestination;
  @attr('boolean', { allowNull: true, defaultValue: null }) declaredPepInBeneficiaries;
  @attr('string', { defaultValue: null }) contractSignStatus; // pending, validation_error, completed

  @hasMany('register-stakeholder', { async: true, inverse: 'organization' }) stakeholders;
  @belongsTo('partner-registration', { async: true, inverse: 'organization' })
  partnerRegistration;
  @belongsTo('register-stakeholder', { async: true, inverse: null }) owner;
  @hasMany('register-document', { async: false, inverse: 'organization' }) documents;

  async register() {
    try {
      let data = {
        organization: {},
      };

      // oxlint-disable-next-line typescript/no-unsafe-assignment
      let organization = await apiAction(this, {
        method: 'POST',
        path: 'register',
        data,
      });
      // oxlint-disable-next-line typescript/no-unsafe-member-access
      this.store.pushPayload('register-organization', organization);
      // oxlint-disable-next-line typescript/no-unsafe-return
      return organization;
    } catch (error) {
      if (error instanceof InvalidError) {
        // private Ember Data method that injects errors in a model
        // recordWasInvalid also throws an error
        // oxlint-disable-next-line typescript/no-unsafe-member-access
        this.store.recordWasInvalid(this._internalModel, error.errors, error);
      } else {
        throw error;
      }
    }
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'register-organization': RegisterOrganization;
  }
}
